export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    classNames: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isVisible: false
    }
  },
  watch: {
    isVisible(newVal) {
      this.$emit('input', newVal)
    },
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.show()
        } else {
          this.hide()
        }
      }
    }
  },
  mounted() {},
  methods: {
    show() {
      this.isVisible = true
    },
    hide() {
      this.isVisible = false
    }
  }
}
